import request from '@/utils/request'
import { noLoginTrack } from './requestUrl'

export const truckingNoTrack = (data) => {
  return request({
    url: noLoginTrack.truckingNoTrack,
    method: 'post',
    notLogin: true,
    data
  })
}
export const newTruckingNoTrack = (baseURL, data) => {
  return request({
    baseURL,
    url: noLoginTrack.newTruckingNoTrack,
    method: 'post',
    notLogin: true,
    data
  })
}

export const translateUrl = (data, baseURL) => {
  return request({
    baseURL,
    url: noLoginTrack.translateUrl,
    method: 'post',
    notLogin: true,
    loading: false,
    data
  })
}
